module.exports = __webpack_public_path__ + "media/images/icons/outlined/check-e5018df9f73700c5dfe4ec6d6b14303a.svg";